import { makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';
import { NextTheme } from '../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  icon: {
    height: 16,
    width: 16,
  },
  iconContainer: {
    padding: theme.spacing(0.5),
    cursor: 'pointer',
  },
  dot: {
    height: 10,
    width: 10,
  },
  selectedDot: {
    color: Colors.textBlack,
  },
  deselectedDot: {
    color: Colors.textGray,
  },
}));
